// @flow

import React, { Component } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';

type Props = {
  localActions: number,
  visiteurActions: number,
  actionType: string,
  isLocal: boolean,
  disableSubRow?: boolean
}

export default class RencontreStatRowSimple extends Component<Props> {

  getProgressWidth = (localActions: number, visiteurActions: number) => {
    const total = localActions + visiteurActions;
    if (localActions === 0) {
      return `0%`;
    }

    return `${(localActions / total) * 100}%`;
  };

  render() {
    const {
      localActions,
      visiteurActions,
      actionType,
      isLocal,
    } = this.props;

    const classNames = dynamicClassName('');
    const scoreBodyClassNames = dynamicClassName('score__body');
    const scoreHeadLocalClassNames = dynamicClassName('score__head__int');
    const scoreHeadVisiteurClassNames = dynamicClassName('score__head__ext');
    const scoreContainerClassname = dynamicClassName('score');

    let progressClassNames = '';

    classNames.add('is-close');
    scoreBodyClassNames.add('is-hidden');

    if (isLocal) {
      progressClassNames = 'is-right';
    }

    if (localActions === 0 && visiteurActions === 0) {
      scoreContainerClassname.add('is-disabled');
    }

    if (localActions > visiteurActions) {
      scoreHeadLocalClassNames.add('is-superior');
    } else if (visiteurActions > localActions) {
      scoreHeadVisiteurClassNames.add('is-superior');
    }

    const seeDetailButtonClasses = '';
    const title = actionType.replace('carton', 'cartons');

    return (
      <div className={scoreContainerClassname.build()}>
        <div className="score__head">
          {/* eslint-disable-next-line */}
          <a className={seeDetailButtonClasses} role="button" tabIndex={0}>
            {`${title.charAt(0).toUpperCase()}${title.slice(1)}s`}
          </a>
          <span className={scoreHeadLocalClassNames.build()}>
            {localActions}
          </span>
          <div>
            <span
              className={progressClassNames}
              style={{ width: this.getProgressWidth(isLocal ? localActions : visiteurActions, isLocal ? visiteurActions : localActions) }}>
            </span>
          </div>
          <span className={scoreHeadVisiteurClassNames.build()}>
            {visiteurActions}
          </span>
        </div>
      </div>
    );
  }
}
